import { render } from "./MainEvents.vue?vue&type=template&id=6b9bd2d5"
import script from "./MainEvents.vue?vue&type=script&lang=js"
export * from "./MainEvents.vue?vue&type=script&lang=js"

import "./MainEvents.vue?vue&type=style&index=0&id=6b9bd2d5&lang=scss"

import exportComponent from "/var/www/sanremo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__